import { render, staticRenderFns } from "./SendAdmissionLetter.vue?vue&type=template&id=068a254c&scoped=true"
import script from "./SendAdmissionLetter.vue?vue&type=script&lang=js"
export * from "./SendAdmissionLetter.vue?vue&type=script&lang=js"
import style0 from "./SendAdmissionLetter.vue?vue&type=style&index=0&id=068a254c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a254c",
  null
  
)

export default component.exports